import formatISO from 'date-fns/formatISO';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import addDays from 'date-fns/addDays';

const DateTime = {
    addDays: (date: Date, days: number) => addDays(date, days),
    format: (date: Date, dateFormat: string) => format(date, dateFormat),
    formatToTimeString: (hours: number) => {
        let minuteCount = Math.round(60 * (hours - Math.floor(hours))).toString();
        minuteCount = minuteCount.length > 1 ? minuteCount : `0${minuteCount}`;
        return `${Math.floor(hours).toString()}h ${minuteCount}m `;
    },
    getISODateString: (date: Date) => formatISO(date, { representation: 'date' }),
    getDateFromISOString: (date: string) => parseISO(date).toString() === 'Invalid Date' ? new Date(date) : parseISO(date),
    formatDateStringToLabel: (date: string) => format(new Date(date), 'eeee, LLL do'),
    subDays: (date: Date, days: number) => DateTime.addDays(date, -days),
};

export default DateTime;
